( function( $ ) {
	// Making this selector a little more specific than usual to prevent any issues from links with only "#"
	$( document ).on( 'click', '[href^="#"]:not([href="#"]):not([data-toggle])', function ( e ) {
		e.preventDefault();
		var $navbar = $( 'nav.navbar' );
		var scrollTopOffset = $navbar.length ? -$navbar.first().outerHeight() : 0;

		$( 'html, body' ).animate( {
			scrollTop: $( $.attr( this, 'href' ) ).offset().top + scrollTopOffset
		}, 300 );
	} );
} )( jQuery );